import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 45 45",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		className: "icon-fill-primary",
		d: "M45 22.5c0-4.6-1-12.3-4.5-12.3h-26V3.4c0-2-2.4-3.4-5.7-3.4-3.2 0-5.5 1.3-5.7 3.2v7.6C.7 12.5 0 18.6 0 22.5c0 4.6 1 12.3 4.5 12.3h25.8v6.9c0 2 2.4 3.4 5.7 3.4 3.2 0 5.5-1.3 5.7-3.2v-7.4c2.5-1.7 3.3-8 3.3-12zm-2.5 0c0 5.8-1.4 9.4-2 9.8h-33C8.6 29.6 9 25.4 9 22.5c0-2.9-.4-7.1-1.6-9.8h32.9c.8.3 2.2 4 2.2 9.8zM5.6 10.2v-4c.9.3 2 .5 3.2.5 1.2 0 2.3-.2 3.2-.5v4H5.6zm3.2-7.7c1.8 0 2.9.6 3.2.9-.2.3-1.3.9-3.2.9s-3-.6-3.2-.9c.2-.3 1.3-.9 3.2-.9zm-6.3 20c0-5.6 1.3-9.2 2-9.7.7.5 2 4.1 2 9.7s-1.3 9.2-2 9.7c-.7-.5-2-4.1-2-9.7zm36.7 12.3v4c-.9-.3-2-.5-3.2-.5-1.2 0-2.3.2-3.2.5v-4h6.4zM36 42.5c-1.8 0-2.9-.6-3.2-.9.2-.3 1.3-.9 3.2-.9s2.9.6 3.2.9c-.3.3-1.4.9-3.2.9z"
	}), /* @__PURE__ */ _jsx("polygon", {
		className: "icon-fill-secondary",
		points: "37.5 20.4 36.2 23.5 32.3 14.7 28.6 21 26.3 18.2 22.4 24.6 18.7 24.6 20.4 22.9 18.6 21.2 15.7 24 12.9 21.2 11.1 22.9 14 25.8 11.1 28.7 12.9 30.4 15.7 27.6 18.6 30.4 20.4 28.7 18.8 27.1 23.8 27.1 26.6 22.5 28.9 25.3 32 20.1 36.3 29.8 39.8 21.3"
	})]
});
export default SvgIcon;
